import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialog) = $event)),
    "max-width": "420",
    teleport: 'body',
    "content-class": "email-dialog"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "headline" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" メール送信先の確認 ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.contactEmail,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contactEmail) = $event)),
                label: "宛先メールアドレス",
                variant: "outlined",
                density: "compact",
                rules: [_ctx.rules.required, _ctx.rules.email]
              }, null, 8, ["modelValue", "rules"]),
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "body-2 text-grey mt-2" }, [
                _createTextVNode(" ※ 添付ファイルをメールにて送信します。"),
                _createElementVNode("br"),
                _createTextVNode(" ※ 送信先の間違いにご注意ください。 ")
              ], -1))
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_actions, { class: "justify-end" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                variant: "text",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("キャンセル", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                color: "primary",
                loading: _ctx.loading,
                onClick: _ctx.onSubmit,
                variant: "flat"
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("メール送信", -1)
                ]))]),
                _: 1
              }, 8, ["loading", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}